/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightBookingHandoffRefreshRequest
 */
export interface FlightBookingHandoffRefreshRequest {
  /**
   * Signed choices from the exact quote seat map. Omit to preserve selections, send [] to clear. Without a Card this stores a nonfinancial draft and clears previous price/consent readiness.
   * @type {Array<string>}
   * @memberof FlightBookingHandoffRefreshRequest
   */
  seatSelectionTokens?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof FlightBookingHandoffRefreshRequest
   */
  quoteId: string;
  /**
   *
   * @type {string}
   * @memberof FlightBookingHandoffRefreshRequest
   */
  paymentMethodToken?: string;
  /**
   * Temporary hosted Card reference, only for an admitted Duffel test quote. Mutually exclusive with payment_method_token.
   * @type {string}
   * @memberof FlightBookingHandoffRefreshRequest
   */
  duffelCardId?: string;
}

/**
 * Check if a given object implements the FlightBookingHandoffRefreshRequest interface.
 */
export function instanceOfFlightBookingHandoffRefreshRequest(
  value: object
): value is FlightBookingHandoffRefreshRequest {
  if (!("quoteId" in value) || value["quoteId"] === undefined) return false;
  return true;
}

export function FlightBookingHandoffRefreshRequestFromJSON(
  json: any
): FlightBookingHandoffRefreshRequest {
  return FlightBookingHandoffRefreshRequestFromJSONTyped(json, false);
}

export function FlightBookingHandoffRefreshRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightBookingHandoffRefreshRequest {
  if (json == null) {
    return json;
  }
  return {
    seatSelectionTokens:
      json["seat_selection_tokens"] == null
        ? undefined
        : json["seat_selection_tokens"],
    quoteId: json["quote_id"],
    paymentMethodToken:
      json["payment_method_token"] == null
        ? undefined
        : json["payment_method_token"],
    duffelCardId:
      json["duffel_card_id"] == null ? undefined : json["duffel_card_id"],
  };
}

export function FlightBookingHandoffRefreshRequestToJSON(
  json: any
): FlightBookingHandoffRefreshRequest {
  return FlightBookingHandoffRefreshRequestToJSONTyped(json, false);
}

export function FlightBookingHandoffRefreshRequestToJSONTyped(
  value?: FlightBookingHandoffRefreshRequest | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    seat_selection_tokens: value["seatSelectionTokens"],
    quote_id: value["quoteId"],
    payment_method_token: value["paymentMethodToken"],
    duffel_card_id: value["duffelCardId"],
  };
}
